import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./PromotionCRUD";
import { promotionSlice } from "./PromotionSlice";

const { actions } = promotionSlice;

export const fetchPromotionList = () => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .postAgent11Api({ action: "promotionlist" })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionListsFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchPromotionList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const fetchPromotionDetail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .postAgent11Api({ action: "promotiondetail", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionDetailFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchPromotionDetail");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const clearPromotionUI = () => (dispatch) => {
  dispatch(actions.clearPromotionUI());
};

export const fetchPromotionUI = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent11Api({ action: "promotionui", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionUIFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchPromotionUI");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const createPromotion = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent11Api({ action: "promotionadd", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionManaged());
          return response;
        }
      } else {
        throw new Error("Error api: createPromotion");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const updatePromotionStatus = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent12Api({ action: "updatepromotionstatus", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionManaged());
          return response;
        }
      } else {
        throw new Error("Error api: updatePromotionStatus");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const copyPromotion = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent21Api({ action: "copyaddpromo", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionManaged());
          return response;
        }
      } else {
        throw new Error("Error api: copyPromotion");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const updatePromotionShareCopy = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent21Api({ action: "promosharecopyonoff", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionManaged());
          return response;
        }
      } else {
        throw new Error("Error api: updatePromotionStatus");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const clearCashSharePromoList = () => (dispatch) => {
  dispatch(actions.cashSharePromoListFetched({ data: null }));
};

export const fetchCashSharePromoList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent21Api({ action: "cshsharepromolist", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.cashSharePromoListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchCashSharePromoList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const updatePromotion = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent12Api({ action: "editpromotion", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionManaged());
          return response;
        }
      } else {
        throw new Error("Error api: updatePromotion");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const removePromotion = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent14Api({ action: "deletepromotion", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionManaged());
          return response;
        }
      } else {
        throw new Error("Error api: deletepromotion");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const generateVoucher = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent12Api({ action: "generatevoucher", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionManaged());
          return response;
        }
      } else {
        throw new Error("Error api: generateVoucher");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const fetchPromotionCaptionList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent12Api({ action: "promotioncaptionlist", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(
            actions.promotionCaptionListsFetched({ data: response.data })
          );
          return response;
        }
      } else {
        throw new Error("Error api: fetchPromotionCaptionList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const manageCaption = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .manageCaption(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionManaged());
          return response;
        }
      } else {
        throw new Error("Error api: manageCaption");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const clearVoucherList = () => (dispatch) => {
  dispatch(actions.clearVoucherList());
};

export const clearCaptionList = () => (dispatch) => {
  dispatch(actions.clearCaptionList());
};

export const fetchVoucherList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent12Api({ action: "promotionvoucherui", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.voucherNotUseListsFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVoucherList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
